var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7483 14.1862C17.9358 14.1862 17.1656 14.3773 16.478 14.7184C15.6771 14.102 14.7823 13.61 13.8192 13.2705C15.7343 12.1347 17.0273 10.0068 17.0273 7.57258C17.0273 3.94851 14.1635 1 10.6436 1C7.12373 1 4.25998 3.94851 4.25998 7.57258C4.25998 10.0251 5.57228 12.1668 7.51108 13.2961C3.72467 14.6625 1 18.3885 1 22.7618H2.36792C2.36792 18.0105 6.10599 14.1449 10.7006 14.1449C12.3832 14.1449 13.9494 14.6651 15.2604 15.5559C14.1795 16.547 13.4971 17.9892 13.4971 19.5929C13.4971 22.5742 15.8529 25 18.7483 25C21.644 25 24 22.5742 24 19.5929C24 16.6117 21.644 14.1862 18.7483 14.1862ZM5.62768 7.57234C5.62768 4.72477 7.87768 2.40817 10.6434 2.40817C13.4091 2.40817 15.6591 4.72477 15.6591 7.57234C15.6591 10.4199 13.4091 12.7365 10.6434 12.7365C7.87791 12.7365 5.62768 10.4199 5.62768 7.57234ZM14.865 19.5929C14.865 17.388 16.6071 15.5946 18.7483 15.5946C19.5725 15.5946 20.336 15.8622 20.9655 16.3146L15.5643 21.8752C15.1247 21.2276 14.865 20.4412 14.865 19.5929ZM18.7483 23.5916C17.9241 23.5916 17.1604 23.3238 16.5311 22.8712L21.9324 17.3106C22.3719 17.9584 22.6319 18.7443 22.6319 19.5931C22.6321 21.7977 20.8898 23.5916 18.7483 23.5916Z",
    fill: "#FF0000",
    stroke: "#F3223C",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/blockIcon.be292ff38af13f1ec0ef91e6b0694a19.svg";
export { ForwardRef as ReactComponent };